import { Component, OnDestroy, OnInit, Input, HostListener } from '@angular/core';
import { OB } from '../../../areas/admin/full-transcript/pages/ob-report/ob.namespace';
import { takeUntil, finalize } from 'rxjs/operators';
import { Page, IUserAccount, PatientProfile, IEncounterResource } from '../../models';
import { HttpService, AppData, EncounterCommunication, TimelineToggleService } from '../../services';
import { ObEncounter } from "@shared/models/ob-encounter.model";
import { Appointment, PreviousAppointment } from '../../entities';
import { ApiResources } from '../../helpers';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { GYNType, OBEncounterType } from "@shared/enums";
import { GYN } from '../../../areas/admin/gyn-encounter/gyn.namespace';

@Component({
    selector: 'ob-header',
    templateUrl: './ob-header.html',    
    styleUrls: ['./ob-header.css'] 
})
export class ObHeaderComponent implements OnDestroy, OnInit {
    @Input() patientId: string;
    @Input() appointmentId: string;
    ancCards: OB.AncCards;
    page: Page;
   // encryptedPatientId: any;
    isAdmission: any;
   // appointmentId: any;


    obEncounter: ObEncounter;
    appointments: any;
    oldAppointment: any;
    vitals: any;
    allergies: OB.Allergies;
    allergiesdata: IEncounterResource;
    antinantalRisk: OB.AntinantalRisk;
    ancCardGeneration: OB.AncCardGeneration;
    ancVisit: OB.Measure;
    encounterCommunicationSubscription: Subscription;
    appointment: Appointment;
    ancCardRecord: OB.AncCardGeneration;
    patient: PatientProfile;
    husbandName: string;
    visitNumber: number;
    specialFeature: OB.SpecialFeature;
    ancCardClosed: OB.AncCardClosure;
    visit: number;
    roleId: number;
    commonData: IEncounterResource;
    gplaJson: GYN.NewGynHistory;
    gpla: OB.AncCards;
    sideNav: boolean;
    constructor(
        private readonly httpService: HttpService,
        private readonly appData: AppData,
        //private readonly notifyService: NotifyService,
        private readonly encounterCommunication: EncounterCommunication,
        private readonly router: Router,
        public timelineService: TimelineToggleService


    ) {            
        this.page = new Page();

    }

    private findAppointment(appointmentId: string) {
        const request = {
            encryptedAppointmentId: appointmentId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<Appointment>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: Appointment) => {
                this.appointment = response;
                this.findPatientDetails();
                this.findAncCard();
                this.fetchAppointmentCounts();
                this.paddingTop();
            });
    }
    private findAncCard() {
        const request = {
            patientId: this.appointment.patientId,
            appointmentId: this.appointment.appointmentId,
            isAdmission: this.isAdmission
        }
        this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.fetchANC), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: OB.AncCardGeneration) => {
                this.ancCardRecord = response;
                this.paddingTop();
            });        
    }
    private findPatientDetails() {
        this.page.loading = true;
        this.httpService.post<PatientProfile>(ApiResources.getURI(ApiResources.patients.base, ApiResources.patients.profile), { encryptedPatientId: this.appointment.encryptedPatientId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: PatientProfile) => {
                if (response) {
                    this.patient = response;
                    var detaills = this.patient.relativeDetails[0];
                    if (detaills && detaills.relation == "Husband") {
                            this.husbandName= this.patient.relativeDetails[0].fullName
                    }
                }
            });
    }

    private fetchAppointmentCounts() {
        const request = {
            patientId: this.appointment.patientId
        };
        this.httpService.get<number>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findVisitNo), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: number) => {
                if (response) {
                    this.visitNumber = response + 1;
                }
                this.findDashboard();
            });
        this.paddingTop();
    }

    private findDashboard() {
        const request = {
            encryptedAppointmentId: this.appointmentId,
            encryptedProviderId: this.page.userAccount && this.page.userAccount.encryptedReferenceId ? this.page.userAccount.encryptedReferenceId : null,
            encryptedPatientId: this.patientId,
            isAdmission: this.isAdmission
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<[ObEncounter, Appointment, PreviousAppointment]>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findEncounterData), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: [ObEncounter, Appointment, PreviousAppointment]) => {
                this.obEncounter = response["dashboard"];
                this.appointments = response["appointments"];
                this.oldAppointment = response["oldAppointment"];
                if (this.obEncounter && this.obEncounter.obEncounterId) {
                    this.vitals = this.obEncounter.vitals ? JSON.parse(this.obEncounter.vitals) : null;
                    this.antinantalRisk = this.obEncounter.antinantalRisk ? JSON.parse(this.obEncounter.antinantalRisk) : null;
                    this.ancCards = this.obEncounter.ancCard ? JSON.parse(this.obEncounter.ancCard) : null;
                    this.allergies = this.obEncounter.allergies ? JSON.parse(this.obEncounter.allergies) : null;
                    this.ancCardGeneration = this.obEncounter.ancCardGeneration ? JSON.parse(this.obEncounter.ancCardGeneration) : null;
                    this.specialFeature = this.obEncounter.specialFeature ? JSON.parse(this.obEncounter.specialFeature) : null;
                    this.ancCardClosed = this.obEncounter.ancCaredClosure ? JSON.parse(this.obEncounter.ancCaredClosure) : null;
                    this.gpla = this.obEncounter.gpla ? JSON.parse(this.obEncounter.gpla) : null;
                 
                    
                    if (this.obEncounter.ancCardGeneration) {
                        this.husbandName = this.ancCardGeneration.husbandName
                    }
                    this.ancVisit = this.obEncounter.measure ? JSON.parse(this.obEncounter.measure) : null;
                    if (this.ancVisit) {
                        this.visit = this.ancVisit && this.ancVisit.visitNumber ? this.ancVisit.visitNumber : this.visitNumber;
                    }
                }
                this.paddingTop();
            });        
    }
    toggleIt() {
        this.timelineService.toggle();
        if (this.timelineService.showBox == false) {
            $("body")[0].setAttribute("data-timeline-size", "timelineabsent");
        } else {
            $("body")[0].setAttribute("data-timeline-size", "timeline");
        }
    }
    toggleSideNav() {
        $(".sidebar-main-menu")[0].classList.toggle("removeLeft"); 
        if ($("body")[0].getAttribute('data-sidebar-size') === "default") {
            $("body")[0].setAttribute("data-sidebar-size", "condensed");
            this.sideNav = true;
        } else if ($("body")[0].getAttribute('data-sidebar-size') === "condensed") {
            $("body")[0].setAttribute("data-sidebar-size", "default");
            this.sideNav = false;
        }
    }
    ngOnInit() {
       this.appData.userAccount
           .pipe(takeUntil(this.page.unSubscribe))
           .subscribe((userAccount: IUserAccount) => {
               if (userAccount) {
                   this.page.userAccount = userAccount;
                   const url = this.router.url;
                   this.isAdmission = url.split("/")[4] === "a";
                   this.appointmentId = url.split("/")[url.split("/").length - 3];
                   this.roleId = this.page.userAccount.roleId;
                   //this.findAppointment(appointmentId);
                   this.encounterCommunicationSubscription = this.encounterCommunication.encounter.subscribe(() => {
                       if (this.appointmentId == "b" || this.appointmentId == "a") {
                           var currentUrl = this.router.url;
                           this.appointmentId = currentUrl.split("/")[currentUrl.split("/").length - 4];
                       }
                       this.findAppointment(this.appointmentId);
                       this.findCommonData();
                    
                   });
               } else {
                   this.page.userAccount = undefined;
               }
           });        
    }
    @HostListener('window:resize')
    onResize() {        
        this.paddingTop();
    }
    @HostListener('window:load')
    onLoad() {
        setTimeout(() => { this.paddingTop();}, 1500)        
    }
    @HostListener('window:hashchange')
    onhashchange() {
        setTimeout(() => { this.paddingTop(); }, 500)
    }
    paddingTop() {
        if (document.getElementById("header") != null && document.getElementsByClassName("content")[0] != null) {
            var paddingTopValue = document.getElementById("header").offsetHeight;
            var content = document.getElementsByClassName("content")[0];
            content.setAttribute('style', `padding-top:${paddingTopValue}px`);
        }
    }
    ngOnDestroy() {
        this.page.unsubscribeAll();
        this.encounterCommunicationSubscription.unsubscribe();
    }



    private findCommonData() {
        const request = {
            encryptedappointmentid: this.appointmentId,
            encryptedpatientid: this.patientId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<IEncounterResource>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findEncounterData), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: IEncounterResource) => {
                this.commonData = response;
                this.gplaJson = this.commonData.jsonString != null ? JSON.parse(this.commonData.jsonString) : null;
                
            });
    }
    safe = (url: any) => {
        if (url) {
            return `${ApiResources.getURI(ApiResources.resources.base, ApiResources.resources.getProfileImage)}?imagePath=${url}`
        }
    }
}